import styled from "styled-components";

export const AiAssistantWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const PowerByShader = styled.div`
    position: absolute;
    width: 200px;
    height: 40px;
    right: 50px;
    top: 2px;
    background-color: rgb(234, 236, 240);
    background-image: linear-gradient(rgba(249, 250, 251, 0.9), rgba(242, 244, 247, 0.9) 3000%);
    z-index: 1000;
`;


